// extracted by mini-css-extract-plugin
export var heroImg = "carouselMiniatures-module--heroImg--31e53";
export var imageWrapper = "carouselMiniatures-module--imageWrapper--98f54";
export var imgDesktop = "carouselMiniatures-module--imgDesktop--e5daa";
export var miniImg = "carouselMiniatures-module--miniImg--e4bfb";
export var miniatures = "carouselMiniatures-module--miniatures--ea5d4";
export var pagination = "carouselMiniatures-module--pagination--0e61d";
export var selected = "carouselMiniatures-module--selected--58073";
export var swiper = "carouselMiniatures-module--swiper--442fd";
export var swiperWrapper = "carouselMiniatures-module--swiperWrapper--6252f";
export var videoPlaceholder = "carouselMiniatures-module--videoPlaceholder--5c323";
export var wrapper = "carouselMiniatures-module--wrapper--99750";